import config from "@Config/index";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import wrapperHOC from "@Utils/wrapperHOC";
import styles from "../PropertyDetailsSectionStyles.module.scss";
import { getPricingCurrency } from "../../PriceTrends/helpers";
import { getAvailableStartingPricingHelper } from "@Pages/BookForm/utils";
import CircleInfo from "@Icons/CircleInfo";
import PriceDisplay from "../../RoomTypeSection/components/RoomTypeCard/components/TenancyCard/components/PriceDisplay";
import { useState } from "react";
import {
  calculateDiscountedPrice,
  getLeaseDurationFormatted,
  getPricingPriceFormatted,
} from "../../RoomTypeSection/utils";

const PricingCompFromSlashPricing = ({
  slashed_price_tenancy_object,
  inventory,
  isDesktop,
  showBillsIncluded,
  showSlashPricing,
  slashed_available_price,
  t,
  pricing,
  pricingDuration,
}: any) => {
  const [showModalForSlashPrice, setShowModaForSlashPricel] = useState(false);
  const handleOnClickPriceTag = (e: React.MouseEvent | React.KeyboardEvent) => {
    e.stopPropagation();
    setShowModaForSlashPricel(true);
  };

  const slashedPrice = calculateDiscountedPrice({
    tenancy: slashed_price_tenancy_object?.tenancy,
    price: getPricingPriceFormatted(slashed_price_tenancy_object?.tenancy?.pricing, {
      price_per_person: true,
    }),
    duration: getLeaseDurationFormatted(slashed_price_tenancy_object?.tenancy?.meta),
    propertyData: inventory,
    roomTypeData: slashed_price_tenancy_object?.roomtype,
    isDesktop,
    showBillsIncluded,
  });

  const CompForSlashPrice = () => (
    <>
      {isDesktop && (
        <div className={styles.greyText}>
          {config.IS_CHINA_APP ? "" : t("propertypage.compactinventorycard.from")}
        </div>
      )}
      {showSlashPricing && slashed_available_price && (
        <>
          <div
            data-testid="property-price"
            className={formatClassNames(styles.slashPricingContainer)}
          >
            <span className={formatClassNames(styles.slashPricing)}>
              {(pricing?.currency && getPricingCurrency(pricing?.currency)) ?? ""}
              {getAvailableStartingPricingHelper(pricing)}
            </span>
            <span className={formatClassNames(styles.discountedPricing)}>
              {(pricing?.currency && getPricingCurrency(pricing?.currency)) ?? ""}
              {slashed_available_price}
            </span>
          </div>
          <div
            className={formatClassNames(
              showSlashPricing ? styles.greyTextWithIcon : styles.greyText,
            )}
            role="none"
            onClick={handleOnClickPriceTag}
          >
            {t("propertypage.components.propertydetailssection.pertext")} {t(pricingDuration || "")}
            <CircleInfo height={12} width={12} />
          </div>
        </>
      )}
    </>
  );
  return (
    <PriceDisplay
      slashedPrice={slashedPrice}
      showOwnPriceComp
      ownPriceComp={CompForSlashPrice}
      isSoldOut={false}
      onPriceClick={handleOnClickPriceTag}
      showModal={showModalForSlashPrice}
      onCloseModal={(e: Event) => {
        e?.stopPropagation();
        setShowModaForSlashPricel(false);
      }}
      toolTipPosition="below"
    />
  );
};

export default wrapperHOC(PricingCompFromSlashPricing, {
  componentName: "PricingCompFromSlashPricing-PropertyPage",
  showForChina: true,
});
